import Modal, { ModalProps } from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { FormattedFormControl } from "@/components/FormControl/FormattedFormControl";
import { ReactSelect } from "@/components/Selects/ReactSelect";
import { StatusSelect } from "@/components/HospitalizationPermits/StatusSelect";
import { IdcsSelect } from "@/components/Selects/IdcsSelect";

type Props = ModalProps;

export function HopitalizationPermitsFiltersModal({ ...rest }: Props) {
	const optionsBeds = [{ value: "4.1 - Internamento", label: "4.1 - Internamento" }];

	return (
		<Modal {...rest}>
			<Modal.Header className="d-flex justify-content-center">
				<Modal.Title>Filtro Avançado</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form className="d-flex flex-column gap-2">
					<FormattedFormControl
						id="hospitalization-start-date"
						label="Data de Início do Internamento"
						defaultValue="09/11/1998"
						formattedFormControlClassName="form-control-solid"
					/>

					<FormattedFormControl
						id="hospitalization-end-date"
						label="Data de Fim do Internamento"
						defaultValue="09/11/1998"
						formattedFormControlClassName="form-control-solid"
					/>

					<Form.Group controlId="status">
						<Form.Label>Status</Form.Label>
						<StatusSelect inputId="status" />
					</Form.Group>

					<Form.Group controlId="tag">
						<Form.Label>Tag</Form.Label>
						<ReactSelect isSolid inputId="tag" className="mb-1" />
					</Form.Group>

					<Form.Group controlId="icd">
						<Form.Label>CID-10</Form.Label>
						<IdcsSelect inputId="icd" />
					</Form.Group>

					<Form.Group controlId="bed">
						<Form.Label>Leito</Form.Label>
						<ReactSelect
							isSolid
							inputId="bed"
							className="mb-1"
							options={optionsBeds}
							defaultValue={optionsBeds[0]}
						/>
					</Form.Group>
				</Form>
			</Modal.Body>
			<Modal.Footer className="d-flex justify-content-center gap-2">
				<Button variant="light" onClick={() => rest.onHide?.()}>
					Cancelar
				</Button>
				<Button>Aplicar</Button>
			</Modal.Footer>
		</Modal>
	);
}
